import { post } from './request';
import * as cmsRequest from './cmsRequest';
//获取json
export const json = (url)=>cmsRequest.get(url);

//个人密码登录
export const LoginByPassword = params => post('/User/LoginByPassword',params,{isEncrypt:true});

//发送重置密码验证码
export const SendVerificationCodeForResetPassword = params => post('/User/SendVerificationCodeForResetPassword',params,{loading:true});

//检查重置密码验证码
export const CheckVerificationCodeForResetPassword = params => post('/User/CheckVerificationCodeForResetPassword',params,{loading:true,code: [2131, 2132, 2133]});

//重置密码
export const ResetPassword = params => post('/User/ResetPassword',params,{isEncrypt:true,loading:true});

//获取机构用户列表
export const GetCompanyList = params => post('/User/GetCompanyList',params,{loading:true});

//获取机构用户列表，(登录成功刷新页面)
export const GetCompanyList_refresh = params => post('/User/GetCompanyList',params,{loading:true,refresh:true});

//切换机构用户
export const SwitchToCompany = params => post('/User/SwitchToCompany',params,{loading:true});

//机构注册并登陆到个人（未登录）
export const PersonalLoginAndRegisterCompany = params => post('/User/PersonalLoginAndRegisterCompany',params);

//检查输入的信息是否可以注册
export const CheckCompanyCanBeRegistered = params => post('/User/CheckCompanyCanBeRegistered',params,{code:[2331,2332,2333,9001]});

//创建机构注册（已登录）
export const CreateCompanyRegister = params => post('/User/CreateCompanyRegister',params);

//修改机构注册信息
export const UpdateCompanyRegister = params => post('/User/UpdateCompanyRegister',params);

//获取机构注册信息
export const GetCompanyRegister = params => post('/User/GetCompanyRegister',params,{loading:true,refresh:true});

//发送登陆/注册验证码
export const SendVerificationCodeForLoginOrRegister = params => post('/User/SendVerificationCodeForLoginOrRegister',params,{loading:true});

//获取用户安全信息
export const GetSecurityInfo = params => post('/User/GetSecurityInfo',params,{isDecrypt:true,loading:true,refresh:true});

//获取用户个人和机构基本资料
export const GetUserProfile = params => post('/User/GetUserProfile',params,{loading:true,refresh:true});

//设置昵称
export const UserSetNickname = params => post('/User/UserSetNickname',params);

//获取实名认证信息
export const UserGetIdentity = params => post('/User/UserGetIdentity',params,{isDecrypt:true,loading:true,refresh:true});
//设置实名认证信息
export const UserSetIdentity = params => post('/User/UserSetIdentity',params,{isEncrypt:true});

//获取单位列表（个人）
export const GetCompanyListAsEmployer = params => post('/User/GetCompanyListAsEmployer',params);
//设置所属单位（个人）
export const SetUserEmployedCompany = params => post('/User/SetUserEmployedCompany',params);

//获取单位列表（机构）
export const GetCompanyListAsParent = params => post('/User/GetCompanyListAsParent',params);
//设置上级单位（机构）
export const SetCompanyParentCompany = params => post('/User/SetCompanyParentCompany',params);

//修改手机号发送验证码
export const SendVerificationCodeForUserChangeMobile = params => post('/User/SendVerificationCodeForUserChangeMobile',params,{loading:true});
//修改手机号
export const UserChangeMobile = params => post('/User/UserChangeMobile',params);

//注销账户发送验证码
export const SendVerificationCodeForUserCloseAccount = params => post('/User/SendVerificationCodeForUserCloseAccount',params,{loading:true});
//注销账户
export const UserCloseAccount = params => post('/User/UserCloseAccount',params);

//发送验证码
export const SendVerificationCode = params => post('/User/SendVerificationCode',params);

//校验验证码
export const CheckVerificationCode = params => post('/User/CheckVerificationCode',params,{code:[2131,2132,2133]});

//修改其他用户手机号
export const ModifySomeUserPhone = params => post('/User/ModifySomeUserPhone',params);
//获取运动项目列表（全部）
export const GetEventsFlatedList = params => post('/Common/GetEventsFlatedList',params);
//获取层级化的运动项目列表（全部）
export const GetLayeredEventsList = params => post('/League/GetLayeredEventsList',params);
//获取层级化的运动项目列表（只包含有认证赛事,认证赛事列表）
export const GetLayeredEventsListOnlyHasMainLeagues = params => post('/League/GetLayeredEventsListOnlyHasMainLeagues',params);

//获取层级化的运动项目列表（只包含有子赛事，赛事广场）
export const GetLayeredEventsListOnlyHasSubLeagues = params => post('/League/GetLayeredEventsListOnlyHasSubLeagues',params);

//获取层级化的运动项目列表（只包含有积分榜单，积分排名）
export const GetLayeredEventsListOnlyHasPointList = params => post('/League/GetLayeredEventsListOnlyHasPointList',params);

//获取层级化的运动项目列表（只包含运动员证书，运动员等级评定列表）
export const GetLayeredEventsListOnlyHasAthleteCertificates = params => post('/League/GetLayeredEventsListOnlyHasAthleteCertificates',params);

//获取层级化的运动项目列表（只包含运动员证书，申请评级）
export const GetLayeredEventsListForAthleteLevelApply = params => post('/AthleteLevel/GetLayeredEventsListForAthleteLevelApply',params);

//获取运动项目的赛事认证定义
export const GetEventsCertificateDefine = params => post('/League/GetEventsCertificateDefine',params,{loading:true});

//新建赛事初审申请
export const NewLeagueInitialApply = params => post('/League/NewLeagueInitialApply',params,{loading:true,refresh:true});

//编辑赛事初审申请
export const EditLeagueInitialApply = params => post('/League/EditLeagueInitialApply',params,{refresh:true});

//提交我的赛事初审申请
export const SubmitLeagueInitialApply = params => post('/League/SubmitLeagueInitialApply',params,{loading: '提交中'});

//认证赛事列表（运动项目或模糊搜索）
export const GetLeagueCertificateList = params => post('/League/GetLeagueCertificateList',params);

//我的认证赛事列表
export const GetMyAuditLeagueList = params => post('/League/GetMyAuditLeagueList',params,{refresh:true});

//我的认证赛事赛季审核列表
export const GetMyAuditLeagueSeasonList = params => post('/League/GetMyAuditLeagueSeasonList',params,{refresh:true});

//获取赛事证书信息
export const GetLeagueCertificate = params => post('/League/GetLeagueCertificate',params,{loading:true})

//获取赛事证书下载信息
export const GetMyLeagueCertificateFile = params => post('/League/GetMyLeagueCertificateFile',params);

//获取积分排行榜
export const GetLeaguePointList = params => post('/Point/GetLeaguePointList',params);

//获取我的积分记录列表
export const GetMyLeaguePointRecordList = params => post('/Point/GetMyLeaguePointRecordList',params,{loading:true});

//获取子赛事列表
export const GetSubLeagueList = params => post('/SubLeague/GetSubLeagueList',params);

//获取子赛事详情
export const GetSubLeagueDetail = params => post('/SubLeague/GetSubLeagueDetail',params,{loading:true});

//获取子赛事的分组名次
export const GetSubLeagueGroupRankingList = params => post('/SubLeague/GetSubLeagueGroupRankingList',params);

//获取我的参赛记录
export const GetMyEnrollRecordList = params => post('/SubLeague/GetMyEnrollRecordList',params);

//获取可申请运动员等级的赛事
export const GetAthleteLevelApplicableSubLeagueWithGroupsList = params => post('/AthleteLevel/GetAthleteLevelApplicableSubLeagueWithGroupsList',params,{loading:true});

//获取可申请运动员等级的参赛者列表
export const GetMyAthleteLevelApplicableTeamList = params => post('/AthleteLevel/GetMyAthleteLevelApplicableTeamList',params,{loading:true});

//获取可申请运动员等级的队伍成员
export const GetMyAthleteLevelApplicableTeamCrew = params => post('/AthleteLevel/GetMyAthleteLevelApplicableTeamCrew',params,{loading:true,code: [2611, 5342]});

//提交团体赛运动员申请
export const CreateAthleteLevelApplyForTeam = params => post('/AthleteLevel/CreateAthleteLevelApplyForTeam',params);

//修改团体赛运动员申请信息
export const UpdateAthleteLevelApplyForTeam = params => post('/AthleteLevel/UpdateAthleteLevelApplyForTeam',params);

//提交个人赛运动员申请
export const CreateAthleteLevelApplyForIndividual = params => post('/AthleteLevel/CreateAthleteLevelApplyForIndividual',params);
//提交组合运动员申请
export const CreateAthleteLevelApplyForDouble = params => post('/AthleteLevel/CreateAthleteLevelApplyForDouble',params);

//获取运动员申请所需数据（我的成绩跳转，带参数）
export const GetAllDataForCreateMyAthleteLevelApply = params => post('/AthleteLevel/GetAllDataForCreateMyAthleteLevelApply',params,{loading:true,refresh:true});

//获取修改运动员申请的数据（我的运动员申请列表跳转）
export const GetMyAthleteLevelCertificateApply = params => post('/AthleteLevel/GetMyAthleteLevelCertificateApply',params,{loading:true,refresh:true});

//获取已评定运动员等级列表
export const GetAthleteCurrentLevelCertificateList = params => post('/AthleteLevel/GetAthleteCurrentLevelCertificateList',params);

//获取我的等级证书列表（普通用户）
export const GetMyAthleteLevelCertificateList = params => post('/AthleteLevel/GetMyAthleteLevelCertificateList',params);

//获取运动员等级证书信息
export const GetAthleteLevelCertificate = params => post('/AthleteLevel/GetAthleteLevelCertificate',params,{loading:true});

//获取运动员等级证书下载信息（单个）
export const GetAthleteLevelCertificateFile = params => post('/AthleteLevel/GetAthleteLevelCertificateFile',params);

//获取我的运动员等级申请列表（机构）
export const GetMyAthleteLevelCertificateApplyList = params => post('/AthleteLevel/GetMyAthleteLevelCertificateApplyList',params,{refresh:true});

//获取运动员等级证书下载信息（多个，批量下载）
export const GetCertificatesPackageFile = params => post('/AthleteLevel/GetCertificatesPackageFile',params);

//获取是否有运动员证书
export const GetAthleteHighestLevel = params => post('/AthleteLevel/GetAthleteHighestLevel',params);
//检查系列赛申请
export const CheckLeagueSerialApply = params => post('/League/CheckLeagueSerialApply',params,{loading: true,refresh:true});
//编辑我的赛事复审申请
export const EditLeagueReviewApply = params => post('/League/EditLeagueReviewApply',params,{loading: true,refresh:true});
//保存 或 保存并提交 我的复审申请
export const SubmitLeagueReviewApply = params => post('/League/SubmitLeagueReviewApply',params,{loading: params.SubmitAfterSave ? '提交中' : '保存中'});
// 获取比赛群设置
export const GetSubleagueMatchGroupSetting = params => post('/Subleague/GetSubleagueMatchGroupSetting',params,{loading: true});

////////////////////// 系列赛 /////////////////////////

//检查系列赛是否有完成的比赛
export const CheckLeagueSerialHaveCompletedLeague = params => post('/LeagueSerial/CheckLeagueSerialHaveCompletedLeague',params);
//获取某个系列赛已完赛的赛事列表
export const GetLeagueSerialCompletedLeagueList = params => post('/LeagueSerial/GetLeagueSerialCompletedLeagueList',params,{loading: true});
//获取系列赛赛事附件
export const GetLeagueSerialLeagueAttachments = params => post('/LeagueSerial/GetLeagueSerialLeagueAttachments',params,{loading: true});

/**
 * 获取字典项列表
 * @param {} params 
 * 行业：subordinate_industry
 * @returns 
 */
export const GetDictionaryItemList = params => post('/Common/GetDictionaryItemList',params);

//获取省级行政区域列表
export const GetProvinceList = params => post('/Common/GetProvinceList',params);
//获取市级行政区域列表
export const GetCityList = params => post('/Common/GetCityList',params);
//获取区县级行政区域列表
export const GetAreaList = params => post('/Common/GetAreaList',params);

//获取用户肖像
export const GetUserPortraitPhoto = params => post('/User/GetUserPortraitPhoto',params);

//获取用户注册信息
export const GetUserRegisInfo = params => post('/User/GetUserRegisInfo',params);

//获取机构列表
export const GetCompanyPageList = params => post('/User/GetCompanyPageList',params);

//获取赛事有组别的比赛项目
export const GetLeagueGroupEvents = params => post('/SubLeague/GetLeagueGroupEvents',params);

//创建代表队
export const CreateDeputation = params => post('/UserDeputation/CreateDeputation',params,{loading:true});

//检查代表队名称重复
export const IsDeputationNameRepeat = params => post('/UserDeputation/IsDeputationNameRepeat',params);

//获取代表队
export const GetDeputationList = params => post('/UserDeputation/GetDeputationList',params);

//获取赛事允许的报名方式
export const GetLeagueEnrollWay = params => post('/UserLeagueEnroll/GetLeagueEnrollWay', params);
//获取报名法律文件信息
export const GetLeagueEnrollInstrument = params => post('/UserLeagueEnroll/GetLeagueEnrollInstrument',params);

//获取报名须知
export const GetLeagueEnrollNotice = params => post('/UserLeagueEnroll/GetLeagueEnrollNotice',params);

//获取最后操作的赛事报名代表队信息
export const GetMyLastOperateEnrollDeputation = params => post('/UserLeagueEnroll/GetMyLastOperateEnrollDeputation',params);

//获取用户是否阅读并同意报名须知
export const GetUserAgreeLeagueEnrollNoticeStatus = params => post('/UserLeagueEnroll/GetUserAgreeLeagueEnrollNoticeStatus',params,{loading:true});
//用户阅读并同意报名须知
export const UserAgreeLeagueEnrollNotice = params => post('/UserLeagueEnroll/UserAgreeLeagueEnrollNotice',params,{loading:true});

//获取报名的代表队信息
export const GetMyEnrollDeputationList = params => post('/UserLeagueEnroll/GetMyEnrollDeputationList',params);

//获取我报名的代表队人员信息
export const GetMyEnrollDeputationUserList = params => post('/UserLeagueEnroll/GetMyEnrollDeputationUserList',params);

//获取我报名的代表队报名组别信息
export const GetMyEnrollDeputationGroupList = params => post('/UserLeagueEnroll/GetMyEnrollDeputationGroupList',params);

//获取我报名的代表队分组人员信息
export const GetMyEnrollDeputationGroupUserList = params => post('/UserLeagueEnroll/GetMyEnrollDeputationGroupUserList',params);

//获取可以加入分组的人员信息
export const GetCanJoinGroupUserList = params => post('/UserLeagueEnroll/GetCanJoinGroupUserList',params);

//获取用户报名所有身份信息
export const GetUserEnrollAllRoleList = params => post('/UserLeagueEnroll/GetUserEnrollAllRoleList',params);

//获取用户可报名的组别
export const GetUserEnrollCanJoinGroupList = params => post('/UserLeagueEnroll/GetUserEnrollCanJoinGroupList',params);

//获取赛事报名身份说明
export const GetLeagueEnrollRoleDesc = params => post('/UserLeagueEnroll/GetLeagueEnrollRoleDesc',params);

//获取赛事报名组别说明
export const GetLeagueEnrollGroupDesc = params => post('/UserLeagueEnroll/GetLeagueEnrollGroupDesc',params);

//在代表队报名队员中检查姓名和手机号
/**
 * 2212 用户已经存在
 * 2214 手机号已注册返回
 * 3871 代表队报名用户手机号已被占用
 * 3905 赛事中已有报名信息
 */
export const CheckPhoneInDeputation = params => post('/UserLeagueEnroll/CheckPhoneInDeputation',params,{code:[3871,2212,2214, 3905]});
//代表队添加队员时获取人员信息
/**
 * 2212 用户已经存在
 * 3905 赛事中已有报名信息
 */
export const GetUserInfoForDeputationAddUser = params => post('/UserLeagueEnroll/GetUserInfoForDeputationAddUser',params,{code:[2212, 3905]});
//获取代表队报名人员是否在其他代表队中报名组别
export const GetDeputationEnrollUserIsEnrollGroupInOtherDpt = params => post('/UserLeagueEnroll/GetDeputationEnrollUserIsEnrollGroupInOtherDpt',params);

//创建代表队报名
export const CreateDeputationEnroll = params => post('/UserLeagueEnroll/CreateDeputationEnroll',params,{loading:true});
//获取代表队报名的代表队信息
export const GetDeputationEnrollDeputationInfo = params => post('/UserLeagueEnroll/GetDeputationEnrollDeputationInfo',params);
//修改报名代表队信息
export const AlterLeagueEnrollDeputationInfo = params => post('/UserLeagueEnroll/AlterLeagueEnrollDeputationInfo',params,{loading:true});
//添加代表队参赛人员
/**
 * 3883 不能在多个代表队担任运动员
 */
export const AddDeputationEnrollUser = params => post('/UserLeagueEnroll/AddDeputationEnrollUser',params,{loading:true, code: [3883]});

//修改代表队参赛人员
export const EditDeputationEnrollUser = params => post('/UserLeagueEnroll/EditDeputationEnrollUser',params,{loading:true, code: [3883]});

//删除代表队参赛人员
export const DeleteDeputationEnrollUser = params => post('/UserLeagueEnroll/DeleteDeputationEnrollUser',params);

//代表队文件上传配置
export const GetAppOwnerDeputationEnrollUploadOptions = params => post('/UserLeagueEnroll/GetAppOwnerDeputationEnrollUploadOptions',params);

//代表队报名提交审核
/**
 * 3901 赛事报名名额不足
 */
export const SubmitDeputationEnroll = params => post('/UserLeagueEnroll/SubmitDeputationEnroll',params,{loading:'提交中', code: [3901]});

//获取我的代表队报名记录
export const GetMyDeputationEnrollRecordList = params => post('/UserLeagueEnroll/GetMyDeputationEnrollRecordList',params);

//获取我的报名记录
export const GetMyLeagueEnrollRecordList = params => post('/UserLeagueEnroll/GetMyLeagueEnrollRecordList',params);

//获取代表队报名详情
export const GetDeputationEnrollRecordDetail = params => post('/UserLeagueEnroll/GetDeputationEnrollRecordDetail',params);

//删除代表队报名组别
export const DelDeputationEnrollGroup = params => post('/UserLeagueEnroll/DelDeputationEnrollGroup',params);

//检查代表队报名运动员未选择组别
export const CheckDeputationEnrollHaveAthleteNoGroup = params => post('/UserLeagueEnroll/CheckDeputationEnrollHaveAthleteNoGroup',params);

//代表队报名成功详情
export const GetDeputationEnrollSuccessDetatil = params => post('/UserLeagueEnroll/GetDeputationEnrollSuccessDetatil',params);

//删除代表队报名
export const DelDeputationEnroll = params => post('/UserLeagueEnroll/DelDeputationEnroll',params);
//获取我参与(领队报名)的代表队报名记录详情
export const GetMyJoinDeputationEnrollRecordDetail = params => post('/UserLeagueEnroll/GetMyJoinDeputationEnrollRecordDetail',params,{loading: true});

//获取赛事报名公示设置
export const GetLeagueEnrollPublicSetting = params => post('/UserLeagueEnroll/GetLeagueEnrollPublicSetting',params);

//获取赛事报名公示名单
export const GetLeagueEnrollPublicNameList = params => post('/UserLeagueEnroll/GetLeagueEnrollPublicNameList',params);

//保存代表队组合报名
export const SaveDeputationEnrollDoubles = params => post('/UserLeagueEnroll/SaveDeputationEnrollDoubles',params);
//获取赛事报名详情
export const GetLeagueEnrollDetailStatistics = params => post('/UserLeagueEnroll/GetLeagueEnrollDetailStatistics',params);
//获取报名的字段配置信息
export const GetLeagueEnrollFieldsOptions = params => post('/UserLeagueEnroll/GetLeagueEnrollFieldsOptions',params);

//获取我的个人报名状态
export const GetMyIndividualEnrollStatus = params => post('/UserLeagueEnroll/GetMyIndividualEnrollStatus', params, {loading: true,code:[3914]});

//检查我是否可以个人报名并返回个人信息
export const CheckMeCanIndividualEnroll = params => post('/UserLeagueEnroll/CheckMeCanIndividualEnroll', params, {loading: true});

//获取个人报名阿里云上传配置
export const GetIndividualEnrollUploadOption = params => post('/UserLeagueEnroll/GetIndividualEnrollUploadOption', params);

//获取允许个人报名的组别
export const GetAllowMeIndividualEnrollGroup = params => post('/UserLeagueEnroll/GetAllowMeIndividualEnrollGroup', params);

//保存我自己的个人报名信息(自己还没报名)
export const SaveMeIndividualEnroll = params => post('/UserLeagueEnroll/SaveMeIndividualEnroll', params, {loading:true});

//检查修改信息报名组别变化
export const CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged = params => post('/UserLeagueEnroll/CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged', params, {loading: true});

//获取我的个人报名
export const GetMyIndividualEnroll = params => post('/UserLeagueEnroll/GetMyIndividualEnroll', params, {loading: true});

//获取我个人报名某个组别的详情
export const GetMyIndividualEnrollOneGroupDetail = params => post('/UserLeagueEnroll/GetMyIndividualEnrollOneGroupDetail', params, {loading: true,code:[3928]});

//个人报名到某个组别
export const IndividualEnrollOneGroup = params => post('/UserLeagueEnroll/IndividualEnrollOneGroup', params, {loading:true});

//个人报名添加队友到双打组检查姓名和手机号
/**
 * 2212 用户已经存在
 * 2214 手机号已经存在
 * 3929 退出添加队友界面，如：双人组合只能一方报名
 * 3905 用户报名基本信息已存在
 * 3931 用户报名组别数量限制
 */
export const IndividualEnrollMateToDoubleCheckUserInfo = params => post('/UserLeagueEnroll/IndividualEnrollMateToDoubleCheckUserInfo', params,{code:[2212,2214,3929, 3905, 3931]});
//个人报名添加队友时获取人员信息
/**
 * 2212 用户已经存在
 * 3905 用户报名基本信息已存在
 */
export const GetUserInfoForIndividualEnrollAddMate = params => post('/UserLeagueEnroll/GetUserInfoForIndividualEnrollAddMate', params,{code:[2212,3905]});

//个人报名添加队友到双打组
//3929 退出添加队友界面，如：双人组合只能一方报名
//3931 用户报名组别数量限制
export const SaveIndividualEnrollDoubleMate = params => post('/UserLeagueEnroll/SaveIndividualEnrollDoubleMate', params, {loading: true, code:[3929, 3931]});

//个人报名删除双打组队友
export const IndividualEnrollDelDoubleMate = params => post('/UserLeagueEnroll/IndividualEnrollDelDoubleMate', params, {loading: true});

//个人报名添加队友检查组别
//3931 用户报名组别数量限制
export const CheckIndividualEnrollChangedGroupsAfterAddMate = params => post('/UserLeagueEnroll/CheckIndividualEnrollChangedGroupsAfterAddMate', params, {loading: true, code: [3931]});

//取消个人报名到某个组别
export const CancelIndividualEnrollGroup = params => post('/UserLeagueEnroll/CancelIndividualEnrollGroup', params, {loading: true});

//个人报名提交审核
/**
 * 3901 赛事报名名额不足
 */
export const SubmitIndividualEnroll = params => post('/UserLeagueEnroll/SubmitIndividualEnroll', params, {loading: '提交中',code: [3901]});

//获取我的个人报名的个人信息
export const GetMyIndividualEnrollPersonalInfo = params => post('/UserLeagueEnroll/GetMyIndividualEnrollPersonalInfo', params, {loading: true, code: true});

//修改我的个人报名的个人信息
export const AlterMyIndividualEnrollPersonalInfo = params => post('/UserLeagueEnroll/AlterMyIndividualEnrollPersonalInfo', params, {loading:true});

//获取我的个人报名的队友信息
export const GetMyIndividualEnrollMateInfo = params => post('/UserLeagueEnroll/GetMyIndividualEnrollMateInfo', params, {loading: true, code: true});

//修改我的个人报名的队友信息
export const AlterMyIndividualEnrollMateInfo = params => post('/UserLeagueEnroll/AlterMyIndividualEnrollMateInfo', params, {loading:true});

//获取我的个人报名成功详情
export const GetMyIndividualEnrollSucessDetail = params => post('/UserLeagueEnroll/GetMyIndividualEnrollSucessDetail', params, {loading: true});

//删除我的个人报名
export const DelMyIndividualEnrollRecord = params => post('/UserLeagueEnroll/DelMyIndividualEnrollRecord', params, {code:[3927]});

//获取用户赛事线上报名状态
export const GetUserLeagueOnlineEnrollStatus = params => post('/UserLeagueEnroll/GetUserLeagueOnlineEnrollStatus', params);
//用户赛事线上报名
export const UserLeagueOnlineEnroll = params => post('/UserLeagueEnroll/UserLeagueOnlineEnroll', params, {loading: true});
/*********************掼蛋大师 */
//获取大师分赛事
export const GetMastersSubLeagueList = params => post('/LeagueMasters/GetMastersSubLeagueList',params);
//获取大师分榜单
export const GetMastersScoreRankPageList = params => post('/LeagueMasters/GetMastersScoreRankPageList',params);
//获取大师等级证书列表
export const GetMastersLevelCertificatePageList = params => post('/LeagueMasters/GetMastersLevelCertificatePageList',params);
//获取大师等级证书信息
export const GetMastersLevelCertificate = params => post('/LeagueMasters/GetMastersLevelCertificate',params);
//获取我的大师分数据
export const GetMyMastersData = params => post('/LeagueMasters/GetMyMastersData',params,{loading:true});
//获取我的大师分全部记录
export const GetMyAllMastersScoreRecordList = params => post('/LeagueMasters/GetMyAllMastersScoreRecordList',params);
//刷新我的大师等级
export const ApplyHigherMastersLevel = params => post('/LeagueMasters/ApplyHigherMastersLevel',params,{loading:true});

/*********************掼蛋申请 */
//刷新我的大师等级
export const GetMyLastApplyLeague = params => post('/GdLeagueApply/GetMyLastApplyLeague',params);

/*********************裁判员 */
//获取所有运动项目及其裁判级别
export const GetAllFlattedEventsRefereeLevelList = params => post('/Common/GetAllFlattedEventsRefereeLevelList',params);
//获取裁判员列表
export const GetRefereeList = params => post('/RefereeCoach/GetRefereeList',params);
//获取裁判员详情
export const GetRefereeDetail = params => post('/RefereeCoach/GetRefereeDetail',params);

//获取用户裁判执裁经历列表
export const GetUserRefereeExperienceList = params => post('/RefereeUser/GetUserRefereeExperienceList',params);
//获取用户裁判执裁经历详情
export const GetUserRefereeExperienceDetail = params => post('/RefereeUser/GetUserRefereeExperienceDetail',params, {loading: true});

/*********************教练员 */
//获取所有运动项目及其教练级别
export const GetAllFlattedEventsCoachLevelList = params => post('/Common/GetAllFlattedEventsCoachLevelList',params);
//获取教练员列表
export const GetCoachList = params => post('/RefereeCoach/GetCoachList',params);
//获取教练员详情
export const GetCoachDetail = params => post('/RefereeCoach/GetCoachDetail',params);

////////////////////// 支付 /////////////////
	
//获取报名缴费状态信息
export const GetUserEnrollPayStatusInfo = params => post('/UserLeagueEnroll/GetUserEnrollPayStatusInfo',params, {loading:true});
//创建代表队赛事报名订单
export const CreateDeputationLeagueEnrollOrder = params => post('/UserLeagueEnroll/CreateDeputationLeagueEnrollOrder',params, {loading:true});
//创建个人赛事报名订单
export const CreateIndividualLeagueEnrollOrder = params => post('/UserLeagueEnroll/CreateIndividualLeagueEnrollOrder',params, {loading:true});
//赛事报名订单支付
export const UserLeagueEnrollGotoPay = params => post('/UserLeagueEnroll/UserLeagueEnrollGotoPay',params, {loading:true});

////////////////////// 培训 /////////////////
	
//获取已发布的培训详情
export const GetPublishTrainDetail = params => post('/UserTrain/GetPublishTrainDetail',params, {loading:true});
//获取培训班级成绩
export const GetTrainClassScoreList = params => post('/UserTrain/GetTrainClassScoreList',params);
//获取培训报名法律文件
export const GetTrainEnrollInstrument = params => post('/UserTrain/GetTrainEnrollInstrument',params);
//获取用户培训报名上传配置
export const GetUserTrainEnrollUploadOption = params => post('/UserTrain/GetUserTrainEnrollUploadOption',params);
//获取培训报名须知
export const GetTrainEnrollNotice = params => post('/UserTrain/GetTrainEnrollNotice',params);
//获取培训报名班级设置
export const GetTrainEnrollClassSetting = params => post('/UserTrain/GetTrainEnrollClassSetting',params);
//保存培训报名学员
export const SaveTrainEnrollStudent = params => post('/UserTrain/SaveTrainEnrollStudent',params);
//获取可报名该班级的备选学员
export const GetEnrolledStudentCanEnrollClass = params => post('/UserTrain/GetEnrolledStudentCanEnrollClass',params);
//提交培训订单
export const SubmitTrainEnrollOrder = params => post('/UserTrain/SubmitTrainEnrollOrder',params);
//获取培训报名报到通知
export const GetUserTrainEnrollCheckinNotice = params => post('/UserTrain/GetUserTrainEnrollCheckinNotice',params, {loading:true});
//培训报名订单支付
export const UserTrainEnrollGotoPay = params => post('/UserTrain/UserTrainEnrollGotoPay',params, {loading:true});

////////////////////// 合作方服务 /////////////////
//获取跳转的用户信息（咪咕）
export const GetJumpUserInfo = params => post('/Partner/GetJumpUserInfo',params, {loading:true});
//获取跳转的员工信息（悦动圈）
export const GetJumpEmployeeInfo = params => post('/Partner/GetJumpEmployeeInfo',params, {loading:true});
